import React from "react";
import { Switch } from "antd";

const ToggleSwitch = ({
  defaultChecked,
  onChange,
  disabled,
  checked,
  checkedChildren,
  unCheckedChildren,
  isEmiCompleted,
}) => {
  const noLabel = !checkedChildren && !unCheckedChildren;

  return (
    <Switch
      defaultChecked={defaultChecked}
      disabled={disabled}
      checked={checked}
      onChange={onChange}
      checkedChildren={checkedChildren}
      unCheckedChildren={unCheckedChildren}
      className={noLabel ? "custom-switch-no-label mt-[1.5px]" : "mt-[1.5px]"}
      style={{
        background:
          checked && isEmiCompleted
            ? "green"
            : checked
              ? "linear-gradient(180deg, #868CFF 0%, #4318FF 100%)"
              : disabled && checked
                ? "linear-gradient(180deg, #868CFF 0%, #4318FF 100%)"
                : defaultChecked
                  ? "linear-gradient(180deg, #868CFF 0%, #4318FF 100%)"
                  : "",
        color: checked ? "white" : undefined,
      }}
    />
  );
};

export default ToggleSwitch;
